import React from 'react';
const FetchIcon = ({ size, color }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" id="data">
            <g fill={color} width={size} height={size} >
                <path d="M10.5 32c.3 0 .5-.1.7-.3l3-3c.4-.4.4-1 0-1.4s-1-.4-1.4 0l-1.3 1.3V17c0-.6.4-1 1-1h26c.6 0 1-.4 1-1s-.4-1-1-1h-26c-1.7 0-3 1.3-3 3v11.6l-1.3-1.3c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l3 3c.2.2.4.3.7.3zM42.2 23.3l-3-3c-.4-.4-1-.4-1.4 0l-3 3c-.4.4-.4 1 0 1.4s1 .4 1.4 0l1.3-1.3V35c0 .6-.4 1-1 1h-26c-.6 0-1 .4-1 1s.4 1 1 1h26c1.7 0 3-1.3 3-3V23.4l1.3 1.3c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4z"></path>
            </g>
        </svg>
    );
};

FetchIcon.defaultProps = {
    size: 100,
    color: "#00ff48ff",
};

export default FetchIcon;

// 002c52ff
